import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7275e956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TranscriptFile" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.computedFileName), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_button, {
        class: "primary text small",
        loading: _ctx.state.is_loading,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadFile(_ctx.file.id)))
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Скачать ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
}